import styled, { css } from 'styled-components';
import { combineValues } from '@cld/theme-helper';
import { Chip, ChipProps } from './Chip';
import { theme } from './theme';

export interface SelectableChipProps extends ChipProps {
  selected?: boolean;
}

export const SelectableChip = styled(Chip)<SelectableChipProps>`
  ${({ selected }) => !selected && css`
    background-color: ${theme.selectable.background.color.unselected};
  `};
  padding: ${combineValues(
    theme.md.padding.vertical,
    theme.selectable.border.width,
    (paddingSize: string, borderWidth: string) => `calc(${paddingSize} - ${borderWidth})`)} ${theme.md.padding.horizontal};
  border: ${theme.selectable.border.width} solid ${theme.selectable.border.color};
  cursor: pointer;
`;
